import { useEffect } from 'react';
import { setAndroidBodyClass } from './utils/platformHelper';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
/* Theme variables */
import './theme/variables.scss';
import './theme/fonts.scss';
import './theme/global/GlobalStyles.scss';
import './App.scss';

import { Browser } from '@capacitor/browser';
import {
  IonApp,
  setupIonicReact,
} from '@ionic/react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import VersionAlert from './components/common/VersionAlert';
import Router from './router/router';
import { persistor, store } from './store';

// eslint-disable-next-line prefer-destructuring
const MCCordovaPlugin = (window as any).MCCordovaPlugin;

MCCordovaPlugin?.setOnNotificationOpenedListener((notification: any) => {
  const url = notification.values.url ? notification.values.url : null;
  if (url.includes('reporting') || url.includes('formation') || url.includes('profile')) {
    window.location.href = url;
  } else {
    window.location.href = '/home';
  }
});

MCCordovaPlugin?.setOnUrlActionListener((urlAction: any) => {
  const { type, url } = urlAction;

  if (type === 'urlAction') {
    if (url.includes('http')) {
      Browser.open({ url });
    } else if (url.includes('reporting') || url.includes('formation') || url.includes('profile')) {
      window.location.href = url;
    }
  }
});

setupIonicReact({
  animated: false,
});

function App() {
  useEffect(() => {
    setAndroidBodyClass();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <IonApp className="chop-app">
          {/* Lo primero al abrir la app, antes del login: avisa si hay que actualizar */}
          <VersionAlert />
          <Router />
        </IonApp>
      </PersistGate>
    </Provider>
  );
}

export default App;
